import clipboardData from './clipboard-data';

export default {
  clipboardData,
};
